module.exports = __webpack_public_path__ + "static/media/passport.a077dcf8.png";